<template>
    <section>
        <ul class="divide-y divide-gray-200 overflow-y-auto" v-if="documents">
            <li
                class="px-6 py-5 relative text-center"
                v-if="documents.length == 0"
            >
                <a
                    class="
                        px-4
                        py-1
                        text-center
                        inline-flex
                        text-sm
                        leading-5
                        font-semibold
                        rounded-full
                        bg-yellow-100
                        text-yellow-800
                    "
                >
                    {{
                        t(
                            "sidebar.docments.none",
                            "Geen documenten beschikbaar"
                        )
                    }}
                </a>
            </li>

            <li
                class="px-6 py-5 relative"
                v-for="(document, subindex) in documents"
                v-bind:key="subindex"
            >
                <div class="group flex justify-between items-center space-x-2">
                    <a class="-m-1 p-1 block">
                        <span
                            class="absolute inset-0 group-hover:bg-gray-50"
                        ></span>
                        <div class="flex-1 flex items-center min-w-0 relative">
                            <div class="ml-4 truncate">
                                <div
                                    class="
                                        text-sm
                                        leading-5
                                        font-medium
                                        text-gray-900
                                        relative
                                    "
                                >
                                    <a :href="document.url">
                                        <svg
                                            class="
                                                flex-shrink-0
                                                h-5
                                                w-5
                                                text-gray-400
                                                absolute
                                            "
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                d="M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z"
                                                clip-rule="evenodd"
                                            />
                                        </svg>

                                        <span class="ml-6">
                                            <span class="truncate">{{
                                                document.name
                                            }}</span>
                                            <a
                                                :href="document.url"
                                                class="
                                                    px-2
                                                    inline-flex
                                                    text-xs
                                                    leading-5
                                                    font-semibold
                                                    rounded-full
                                                    bg-indigo-100
                                                    text-indigo-800
                                                    mr-2
                                                    ml-2
                                                    transition
                                                    hover:text-indigo-900
                                                    hover:bg-indigo-200
                                                    duration-150
                                                    ease-in-out
                                                "
                                            >
                                                {{ t("download", "Download") }}
                                            </a>
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </li>
        </ul>
    </section>
</template>

<script>
// import { ArrowSmDownIcon, ArrowSmUpIcon } from "@heroicons/vue/solid";
// import {
//     CursorClickIcon,
//     MailOpenIcon,
//     UsersIcon,
// } from "@heroicons/vue/outline";

// const stats = [
//     {
//         id: 1,
//         name: "Total Subscribers",
//         stat: "71,897",
//         icon: UsersIcon,
//         change: "122",
//         changeType: "increase",
//     },
// ];

export default {
    mounted() {
        let self = this;
        setTimeout(function () {
            self.isOn = true;
        }, 2000);

        this.getDocuments();
    },
    created() {
        let self = this;
        window.setInterval(() => {
            self.getDocuments();
        }, 50000);
    },
    components: {
        // ArrowSmDownIcon,
        // ArrowSmUpIcon,
    },
    props: ["meeting"],
    data() {
        return {
            isOn: false,
            documents: null,
        };
    },
    methods: {
        getDocuments() {
            var self = this;
            axios
                .get("/api/documenten?meeting_slug=" + this.meeting)
                .then((response) => {
                    console.info("getDocuments");
                    console.info(response.data);

                    this.documents = response.data.data;
                    this.open = true;
                    Eventing.fire("formMeeting");
                    setTimeout(() => {
                        self.opened = true;
                    }, 40);
                })
                .catch((error) => {
                    // alert(error.response.status);
                });
        },
    },
};
</script>
